<template>
  <div class="is-flex is-justify-content-flex-end is-flex-direction-column" style="height:100%;" >
    <div class="box is-flex-grow-1 m-0 mb-4" style="overflow:scroll;" ref="scrollable">
      <div :dir="conversation.created_by == 'System' ? 'rtl' : 'ltr'" v-for="conversation in conversations" :key="conversation.id" class="message is-dark has-border-none">
        <div  class="message-body columns" :class="conversation.created_by == 'System' ? '' : 'is-flex-direction-row-reverse'" :style="conversation.created_by == 'System' ? 'background: hsl(171, 100%, 96%);' : ''">
          <div class="column p-0 has-text-right" style="word-break:break-all;">{{ conversation.content }}</div>
          <div class="column p-0 is-4 has-text-centered">
            <p>{{ $moment(conversation.created_at).format('DD/MM/YYYY HH:mm') }}</p>
            <p v-if="conversation.designator == 'whatsapp_voice_message'" class="is-size-7">תומלל מהודעה קולית</p>
          </div>
        </div>
      </div>
    </div>
    <ApplicantBlockBanner v-if="isBlocked" :applicant="applicantData" class="mx-4" @released="onBlockReleased" />
    <!-- blocked candidate (v2): history stays readable, no input, and NO manual override -->
    <div v-if="isBlocked" class="has-text-right mx-4 mb-4" dir="rtl" data-test="wa-blocked-note">
      <span class="is-size-7">{{ blockedMessage }}</span>
    </div>
    <div v-else-if="!canSendWhatsapp" class="has-text-left mx-4">
      <button class="button is-info is-small mb-4 mx-4" @click="removeRestrictWhatsappDate">אשר שליחה ידנית</button>
      <span class="is-size-7">
        This applicant cannot receive messages due to their request
      </span>
    </div>
    <div v-else>
      <div v-if="applicantData" class="box m-0 is-flex is-align-items-end is-justify-content-space-between">
        <div v-if="conversationOpened" class="is-flex-grow-1">
          <textarea class="textarea" v-model="message" placeholder="Message"></textarea>
        </div>
        <div v-else>
          <select class="ltr" v-model="templateToSend">
            <option>send_initial_message</option>
            <option>send_reminder_message</option>
          </select>
        </div>
        <div class="field has-addons">
          <button class="button is-info" @click="onSubmit">Submit</button>
          <button class="button is-warning mr-3" @click="getConversations">Refresh</button>
        </div>
      </div>
      <div v-if="offerData" class="box m-0 mt-3 is-flex is-align-items-end is-justify-content-space-between">
        <p>האם תרצי לשלוח הצעת עבודה ל - {{ offerData.position.title }} ?</p>
        <div class="field has-addons">
          <button class="button is-info mr-3" @click="onSendProposul">Send</button>
          <button class="button is-warning mr-3" @click="getConversations">Refresh</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicantBlockBanner from '@/components/ApplicantBlockBanner.vue'
import { BLOCKED_TOAST, isApplicantBlocked, markReleased } from '@/custom/helpers/applicant_block.js'

export default {
  name: 'ModalWhatsappMessager',
  components: { ApplicantBlockBanner },
  props: {
    payload: {
      type: Object,
      default: () => {}
    },
    hideLogs: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      message: '',
      templateToSend: '',
      conversations: [],
      applicantData: this.payload.props.applicant,
      offerData: this.payload.props.offer || null,
      blockedMessage: BLOCKED_TOAST
    }
  },
  computed: {
    isBlocked () {
      return isApplicantBlocked(this.applicantData)
    },
    conversationOpened () {
      if (this.applicantData) {
        return this.applicantData.whatsapp_free_conversation
      }
      return false
    },
    canSendWhatsapp () {
      if (this.applicantData.restrict_whatsapp_date) {
        const restrictDate = new Date(this.applicantData.restrict_whatsapp_date)
        const today = (new Date()).setHours(0, 0, 0, 0)
        if (restrictDate > today) {
          return false
        }
      }
      return true
    }
  },
  created () {
    this.getConversations()
  },
  methods: {
    scrollToBottom () {
      const container = this.$refs.scrollable
      container.scrollTop = container.scrollHeight
    },
    onBlockReleased () {
      markReleased(this, this.applicantData)
    },
    async onSubmit () {
      // Last line of defence: the input is not rendered while blocked.
      if (this.isBlocked) {
        this.$utils.emit('show_toast', { text: BLOCKED_TOAST, type: 'error' })
        return
      }
      try {
        const event = this.conversationOpened ? 'send_freetext_whatsapp_to_applicant' : 'send_whatsapp_template'
        const text = this.conversationOpened ? this.message : this.templateToSend
        await this.$network_utils.postEvent({
          event: event,
          current_type: 'Applicant',
          current_resource_id: this.applicantData.resource_id,
          text: text
        })
        await this.getConversations()
        this.message = ''
      } catch (error) {
        console.log(error)
      }
    },
    onSendProposul () {
      if (this.isBlocked) {
        this.$utils.emit('show_toast', { text: BLOCKED_TOAST, type: 'error' })
        return
      }
      this.$network_utils.postEvent({
        event: 'send_whatsapp_offer_template',
        current_type: 'Offer',
        current_resource_id: this.offerData.id,
        owner: this.$utils.getOwner().name,
        text: 'send_propose_offer'
      })
    },
    async removeRestrictWhatsappDate () {
      if (this.isBlocked) return
      await this.$network_utils.updateApplicant({ applicant_id: this.applicantData.resource_id, restrict_whatsapp_date: 'null' })
      this.$utils.emit('show_toast', { text: 'WhatsApp restriction removed' })
      this.applicantData.restrict_whatsapp_date = undefined
    },
    async getConversations () {
      const designator = 'whatsapp_message,whatsapp_voice_message,whatsapp_template_send'
      this.conversations = await this.$network_utils.getConversation({
        applicant_id: this.applicantData.resource_id,
        sort: 'created_at',
        ...(this.hideLogs && { designator })
      })
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    }
  }
}
</script>
